webpackJsonp([17],{

/***/ 341:
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//

/* harmony default export */ __webpack_exports__["a"] = ({
  components: {
    Topic: function Topic() {
      return __webpack_require__.e/* import() */(21/* duplicate */).then(__webpack_require__.bind(null, 96));
    }
  },
  data: function data() {
    return {
      tags: ['Culture', 'Exploration']
    };
  }
});

/***/ }),

/***/ 342:
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('topic',{attrs:{"speaker":"Gary Kwong","title":"Discussion on cultural differences between Easterners & Westerners","icon":"/2017/img/speaker/gary.jpg","community":"Mozilla","time":"15:45 - 16:30","venue":"LT 18","tags":_vm.tags,"language":"Cantonese / English","live":"https://www.youtube.com/watch?v=JSuDQAw8nME"}},[_c('p',{attrs:{"slot":"speaker"},slot:"speaker"},[_vm._v("\n    Gary Kwong is a senior security engineer at Mozilla and a long-time member of its community.\n    He specialises in running JavaScript fuzzers that rigorously test SpiderMonkey -\n    the JavaScript engine of the Gecko platform on which Mozilla Firefox is based.\n    Gary is passionate about global cultures, human languages, and lately, ballroom/swing dancing.\n  ")]),_vm._v(" "),_c('p',{attrs:{"slot":"abstract"},slot:"abstract"},[_vm._v("\n    In various global open source communities (e.g. Mozilla), we frequently have to deal with people from different languages and cultures.\n    Very often, miscommunication arises even when there is no ill-will on either side.\n    This discussion aims to raise awareness of some of these differences and will share some tips on how to bridge these gaps,\n    in order to improve relationships on either side.\n  ")])])}
var staticRenderFns = []
var esExports = { render: render, staticRenderFns: staticRenderFns }
/* harmony default export */ __webpack_exports__["a"] = (esExports);

/***/ }),

/***/ 84:
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
Object.defineProperty(__webpack_exports__, "__esModule", { value: true });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vue_loader_lib_selector_type_script_index_0_CultureDifferences_vue__ = __webpack_require__(341);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__node_modules_vue_loader_lib_template_compiler_index_id_data_v_5c1034f2_hasScoped_false_node_modules_vue_loader_lib_selector_type_template_index_0_CultureDifferences_vue__ = __webpack_require__(342);
var normalizeComponent = __webpack_require__(1)
/* script */

/* template */

/* styles */
var __vue_styles__ = null
/* scopeId */
var __vue_scopeId__ = null
/* moduleIdentifier (server only) */
var __vue_module_identifier__ = null
var Component = normalizeComponent(
  __WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vue_loader_lib_selector_type_script_index_0_CultureDifferences_vue__["a" /* default */],
  __WEBPACK_IMPORTED_MODULE_1__node_modules_vue_loader_lib_template_compiler_index_id_data_v_5c1034f2_hasScoped_false_node_modules_vue_loader_lib_selector_type_template_index_0_CultureDifferences_vue__["a" /* default */],
  __vue_styles__,
  __vue_scopeId__,
  __vue_module_identifier__
)

/* harmony default export */ __webpack_exports__["default"] = (Component.exports);


/***/ })

});


// WEBPACK FOOTER //
// 17.c754391fb8c77f6a4806.js